module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Mailbox-7984de84b77c3de787c086ef35236e6c.svg";